module.exports = __webpack_public_path__ + "media/Raven_Red_Blue.23.674cf3ae.webm";